<template>
	<div class="col rate-col">
		<div v-if="showDatePicker">
			<b-form-datepicker size="sm" :date-disabled-fn="dateDisabled" @context="onDatePicked" v-model="date1"
				class="mb-1" today-button close-button locale="zh"
				:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short' }"></b-form-datepicker>
		</div>
		<div v-else class="date-header">
			{{ formattedDate }}
		</div>
		<div v-if="stocks.length" class="plate-items-container">
			<div v-bind:key="data.index" v-for="(data) in stocks.slice(0, top_n)" class="mb-1" :class="{ 'plate-focus': focusEnabled && prevCodes && prevCodes.indexOf(data.plate_code) === -1 }">
				<PlateTextMoreItem :plate_name="show_rate ? (data.plate_name + ' (' + data.sum_rate + ')') : data.plate_name" :plate_code="data.plate_code" :pct=data.sum_rate
				:c_num="show_score == 1 ? data.sum_score : ''" :selected="data.plate_code === selectedPlateCode" :num1="(data.sum_leader_money/100000000).toFixed(2)" :num2="(data.last_day.money_leader/100000000).toFixed(2)"
				:is_show_row2="is_show_row2"
					@click="handlePlateClicked(data.plate_code)"></PlateTextMoreItem>
			</div>
		</div>
		<div v-else>
			<span>loading...</span>
		</div>
		<div>
			<UplimitStepOnPlate v-if="showUplimitStep" :plate_code=selectedPlateCode :date1="date1" :showMinChart="showMinChart" @show_sidebar="handleShowSidebar" @show-plate-kline="handleShowPlateKline"></UplimitStepOnPlate>
		</div>
	</div>
</template>

<script>
	import {
		request_zzquant
	} from "network/request.js"

	import PlateTextMoreItem from 'components/plate/PlateTextMoreItem.vue'
	import UplimitStepOnPlate from 'components/uplimit/UplimitStepOnPlate.vue'

	export default {
		props: {
			date1: String,
			selectedPlateCode: String,
			plate_type: {
				type: Number,
				default: 15,
			},
			show_rate: {
				type: Boolean,
				default: true
			},
			showUplimitStep: {
			type: Number,
			default: 0, // 默认不显示
			},
			show_score:{
				type: Number,
				default: 1,
			},
			is_show_row2: {
				type: Boolean,
				default: false,
			},
			focusEnabled: {
				type: Boolean,
				default: false,
			},
			showMinChart: {
				type: Boolean,
				default: false,
			},
			prevCodes: {
				type: Array,
				default: () => []
			},
			data_src: {
				type: Number,
				default: 1,
			},
			n_days: {
				type: Number,
				default: 5,
			},
			n_type: {
				type: Number,
				default: 3, // 1=涨幅, 3=资金净额, 9=强度
			},
			top_n: {
				type: Number,
				default: 12,
			},
			showDatePicker: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				stocks: []
			};
		},
		computed: {
			formattedDate() {
				if (!this.date1) return '';
				try {
					const d = new Date(this.date1);
					const yy = String(d.getFullYear()).slice(-2);
					const mm = String(d.getMonth() + 1).padStart(2, '0');
					const dd = String(d.getDate()).padStart(2, '0');
					const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
					return `${yy}/${mm}/${dd} ${weekdays[d.getDay()]}`;
				} catch (e) {
					return this.date1;
				}
			}
		},
		components: {
			PlateTextMoreItem,
			UplimitStepOnPlate
		},
		mounted() {
			this.refresh_popular();
		},
		watch: {
			// 监听data_src参数变化，触发数据刷新
			data_src() {
				this.refresh_popular();
			},
			n_days() {
				this.refresh_popular();
			}
			,
			n_type() {
				this.refresh_popular();
			},
			date1() {
				this.refresh_popular();
			}
		},
		methods: {
			handlePlateClicked(plateCode) {
				// 从stocks数组中找到对应的plate_name
				const plateItem = this.stocks.find(item => item.plate_code === plateCode);
				const plateName = plateItem ? plateItem.plate_name : '';
				// 发送事件时同时传递plateCode和plateName
				// console.log(plateCode, plateName)
				this.$emit('plate-selected', plateCode, plateName)
			},
			handleShowSidebar(stock_info) {
				this.$emit('show_sidebar', stock_info)
			},
			handleShowPlateKline(plateInfo) {
				this.$emit('show-plate-kline', plateInfo)
			},
			mendZero(num) {
				return (num = num < 10 ? '0' + num : num)
			},
			onDatePicked() {
				// console.log(ctx.selectedYMD);
				this.refresh_popular();
			},
			dateDisabled(ymd, date) {
				const weekday = date.getDay();
				const time = date.getTime()

				const now = new Date();
				const now_time = now.getTime();
				// 周六日不能选
				if (weekday === 0 || weekday === 6) {
					return true;
				}
				//今天之后不能选
				if (time >= now_time) {
					return true;
				}
				return false
			},
			refresh_popular() {
				// console.log(this.date1)
				request_zzquant({
						// url: 'stock/d/popular/' + this.date1
						// url: '/market/plates/25/rank/popular?date1=' + this.date1 + '&top_n=20'
						
					url: '/market/plates/' + this.plate_type + '/rank/days?date2=' + this.date1 + '&n_days=' + this.n_days + '&data_src=' + this.data_src + '&n_type=' + this.n_type
				})
					.then(res1 => {
						this.stocks = res1['data']['data'];
						if (this.stocks.length > 0) {
							this.$emit('first-plate-loaded', this.stocks[0].plate_code, this.date1);
							this.$emit('plates-loaded', { day: this.date1, codes: this.stocks.map(s => s.plate_code).filter(Boolean) });
						}
					})
					.catch(err => {
						console.log(err);
					});
			},
			p_show_kline(symbol_code) {
				// console.log("p click "+symbol_code);
				this.$emit('p_show_kline', symbol_code)
			}
		},
		filters: {
			toFixedTwo(value) {
				if (!value) return '';
				value = Number(value);
				return value.toFixed(2);
			}
		},
	};
</script>

<style>
	.plate-focus{
		background-color: rgba(255, 193, 7, 0.1);
		box-shadow: inset 0 0 0 1px var(--accent-color, #faad14);
		border-radius: 3px;
		padding: 0px 1px;
	}
	body.theme-dark .plate-focus {
		background-color: rgba(255, 193, 7, 0.2);
	}
	.rate-col{
		padding-left: 4px;
		padding-right: 4px;
	}
	.date-header {
		font-size: 0.85rem;
		font-weight: 700;
		color: #555;
		background-color: #f1f3f5;
		border-bottom: 1px solid #dee2e6;
		border-radius: 4px;
		padding: 4px 0;
		margin-bottom: 6px;
		text-align: center;
		letter-spacing: 0.5px;
		line-height: 1.2rem;
		min-height: 31px;
	}
	body.theme-dark .date-header {
		color: var(--accent-color, #faad14);
		background-color: rgba(255, 255, 255, 0.05);
		border-bottom-color: rgba(255, 255, 255, 0.1);
	}
</style>
